$(document).ready(function () {
  /*******account-tabs-start*******/
  $("ul.account-tabs-ul li.tab-heading.tab-click").on("click", function () {
    $(this).siblings().removeClass("active");
    $(this).addClass("active");
    let get_data_show = $(this).attr("data-show");
    $(".tab-content-inner").hide();
    $(".tab-content-inner." + get_data_show).show();

    let currentUrl = window.location.href;
    if ($(this).attr("data-show") == "my-details") {
      let newUrl = window.location.pathname + "?open=details";
      history.replaceState(null, null, newUrl);
      $('.account-saved-address').hide();
      $('.account-details-wrp').show();
    }
    else if($(this).attr("data-show") == "my-order"){
      let sec_newUrl = window.location.pathname;
      history.replaceState(null, null, sec_newUrl);
    }
  });

  $(".order_items_sigma_div .view-order-details").on("click", function () {
    let get_data_show = $(this).attr("data-show");
    $(".account-tabs-content-wrp .body-step-first").hide();
    $(".details-show-content." + get_data_show).show();
  });

  $(".details-show-content .revirse-button-order").on("click", function () {
    $(".details-show-content").hide();
    $(".account-tabs-content-wrp .body-step-first").show();
  });

  $(".popup_close_js").on("click", function () {
    $(".popup_main_js").hide();

  });

  $(".view-saved-addresses").on("click", function () {
    $(".account-details-wrp").hide();
    $(".account-saved-address").show();
  });
  $(".account-saved-address .back-to-details").on("click", function () {
    $(".account-details-wrp").show();
    $(".account-saved-address").hide();
  });

  $(".customer_address_edit.popup_click_onlt_css.popup_click_only_js").on(
    "click",
    function () {
      $(this)
        .closest("li.customer_address_actions_inner")
        .find(".customer_address_edit_main")
        .show();
    }
  );

  var get_params = new URLSearchParams(window.location.search);
  if (get_params.get("open") === "details-addresses") {
    $('li.tab-heading.tab-click[data-show="my-details"]').click();
    $(".account-details-wrp").hide();
    $(".account-saved-address").show();
    console.log(465456);
  }
  else if(get_params.get("open") === "details"){
    $('li.tab-heading.tab-click[data-show="my-details"]').click();
  }

  /**** delete address ajax------start*****/
  $(".customer_address_del_form").submit(function (e) {
    e.preventDefault();

    var form = $(this);
    var confirmMessage = form.data("confirm-message");

    if (confirm(confirmMessage)) {
      $.ajax({
        type: "POST",
        url: form.attr("action"),
        data: form.serialize(),
        success: function (response) {
          console.log("Address deleted successfully:", response);
          location.reload();
        },
        error: function (xhr, status, error) {
          console.error("Error deleting address:", error);
        },
      });
    }
  });
  /**** delete address ajax------end*****/

  /*******account monthes filter--start*********/
  $("#last-months").on("change", function () {
    console.log(465);
    var selectedMonths = parseInt($(this).val()); // Get the selected months
    var currentDate = new Date();

    $(".order_items_sigma_div").each(function () {
      var orderDate = new Date($(this).data("order-date"));
      var monthsDiff =
        (currentDate.getFullYear() - orderDate.getFullYear()) * 12 +
        (currentDate.getMonth() - orderDate.getMonth());

      if (monthsDiff <= selectedMonths) {
        $(this).show();
      } else {
        $(this).hide();
      }
    });
  });
  $("#last-months").trigger("change");
  /*******account monthes filter--end*********/

  /*******account-tabs-end*******/

  // var $description = $(".product-description .description-content");
  // var $firstElement = $description.children().first();
  // var $otherElements = $firstElement.nextAll();
  // var $readMore = $(".read-more");
  // var $readLess = $(".read-less");
  // $otherElements.hide();
  // $readMore.on("click", function () {
  //   $otherElements.slideDown();
  //   $readMore.hide();
  //   $readLess.show();
  // });

  // $readLess.on("click", function () {
  //   $otherElements.slideUp();
  //   $readMore.show();
  //   $readLess.hide();
  // });

  $('.product-info-container .read-more').on('click',function(){
     $('html, body').animate({
        'scrollTop' : $(".product-features-main-wrp").position().top
    });
  });

  $(".custom-accordion-head").on("click", function () {
    $(".custom-faq .accordion details").removeAttr("open");
    var ctm_data_show = $(this).attr("data-show");
    if ($(".left-image ." + ctm_data_show).length > 0) {
      $(".left-image .accor-img-ctm").hide();
      $(".left-image ." + ctm_data_show).show();
    }
  });

  $(".saved_addresses-header .plus_icon_address").on("click", function () {
    $(".address_popup_main.popup_main_css").show();
  });

  // Custom-code 

  $(".toggle-edit-form").on("click", function () {
    var index = $(this).data("index");
    $(".add-form-container[data-index='" + index + "']").toggle();
    $(".address_occurs[data-add-index='" + index + "']").toggle();
    
});

$(".show-address").on("click", function () {
  var index = $(this).data("index");
  $(".address_occurs[data-add-index='" + index + "']").show();


})



});
